import React, { useEffect } from 'react'
import './Sadguru_arpanam.css'
import Banner from './banner/Banner'
import Sadguru_content from './sadguru-content/Sadguru_content'
import { useDispatch, useSelector } from 'react-redux'
import { UPcomingFestival } from '../../features/admin/common/Slice'
import { IDS } from '../../utils/IDS'

const Sadguru_arpanam = () => {
  const dispatch = useDispatch();
  const festival = useSelector((state) => state.common.coming_festival);


  useEffect(() => {
    dispatch(UPcomingFestival());
  }, [dispatch])
  return (
    <>
      <Banner image={IDS.IMG_URL + festival?.Festival?.background_image} />
      <Sadguru_content festival={festival} />
    </>
  )
}

export default Sadguru_arpanam